export const process = {
  env: {},
  argv: {},
  version: '',
  versions: {},
  platform: 'browser',
  browser: true,
  cwd: () => '/mock',
}
